import {Component, signal, inject} from '@angular/core';
import {ContactComponent} from "../../../shared/components/contact/contact.component";
import {NbDialogService, NbInputModule, NbOptionModule, NbSelectModule, NbToastrService} from "@nebular/theme";
import {AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {
  LeagueCenteredComponent
} from "../../../shared/components/league-centered/league-centered.component";
import {LeagueComponent} from "../../../shared/components/league/league.component";
import {ActivatedRoute, Router} from "@angular/router";
import {TeamsService} from "../../../services/teams.service";
import {notificationsParams} from "../../../shared/settings";
import {TicketFormComponent} from "../ticket-form/ticket-form.component";
import {Title} from "@angular/platform-browser";
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-player-registration',
  standalone: true,
  imports: [
    TranslateModule,
    ContactComponent,
    NbInputModule,
    ReactiveFormsModule,
    LeagueCenteredComponent,
    LeagueComponent,
    NbOptionModule,
    NbSelectModule
  ],
  templateUrl: './player-registration.component.html',
  styleUrl: './player-registration.component.scss'
})
export class PlayerRegistrationComponent {
  private readonly translate = inject(TranslateService);
  isCaptainSigningUp: any = signal<boolean>(false);
  activisionIds: any = signal<any[]>([]);
  registerPlayerForm!: FormGroup;
  message = 'Get signed up for B06 Season 1 of ECL League';
  private teamId: string = '';
  currentTitle!: string;

  constructor(
    private readonly title: Title,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: NbDialogService,
    private teamsService: TeamsService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.currentTitle = this.title.getTitle();
    this.teamId = this.route.snapshot.params['team_id'];
    this.isCaptainSigningUp = !!this.route.snapshot.queryParams['captain'];

    const email = this.route.snapshot.queryParams['email'];

    this.registerPlayerForm = new FormGroup(
      {
        consent: new FormControl(false, [Validators.required]),
        team_player_id: new FormControl(''),
        email: new FormControl('', [Validators.required, Validators.minLength(8)]),
        password: new FormControl('', [Validators.required]),
        password_confirmation: new FormControl('', [Validators.required])
      },
      { validators: this.passwordMatchValidator }
    );

    if (email) {
      this.registerPlayerForm.patchValue({ email: email });
    }

    this.teamsService.activisionIds(this.teamId).subscribe((activisionIds: any) => {
      this.activisionIds.set(activisionIds)
    });
  }

  passwordMatchValidator(form: AbstractControl) {
    return form.get('password')?.value === form.get('password_confirmation')?.value
      ? null : { 'mismatch': true };
  }

  onSubmit() {
    const params = this.registerPlayerForm.value;

    if (this.isCaptainSigningUp) {
      this.teamsService.registerCaptain(this.teamId, params.email, params.password, params.password_confirmation, params.consent).subscribe({
        complete: () => {
          this.toastrService.success(this.translate.instant('teams.player_registration.account_created'), this.translate.instant('common.information'), notificationsParams);
          this.router.navigate(['/auth/login'], { queryParams: { username: params.email } })
        },
        error: (e) => {
          const message = e?.error?.message || e?.message
          this.toastrService.danger(message, this.translate.instant('common.error'), notificationsParams);
        }
      })
    }
    else {
      this.teamsService.registerPlayer(this.teamId, params.team_player_id, params.email, params.password, params.password_confirmation, params.consent).subscribe({
        complete: () => {
          this.toastrService.success(this.translate.instant('teams.player_registration.player_registered'), this.translate.instant('common.information'), notificationsParams);
          this.router.navigate(['/auth/login'], { queryParams: { username: params.email } })
        },
        error: (e) => {
          const message = e?.error?.message || e?.message
          this.toastrService.danger(message, this.translate.instant('common.error'), notificationsParams);
        }
      })
    }
  }

  createTicket() {
    this.dialogService.open(TicketFormComponent, {
      dialogClass: 'popup',
      context: {
        team_id: this.teamId,
        email: this.registerPlayerForm.value.email,
      },
    });
  }
}
